export const callSizeChart = (espot, returnHTML) => {
    $.ajaxQueue({
        cache: true,
        type: "GET",
        dataType: "json",
        url: "/webapp/wcs/stores/servlet/NonCacheESpot",
        data: "emsName=" + espot + "&maxNumDisp=1&storeId=301&catalogId=301&langId=-1",
        success: function(json) {
            var successResp = json.JSON;
            if (successResp != null) returnHTML(successResp.eSpotContent0 == null ? "" : successResp.eSpotContent0);
            // Target 16237 add size chart link to quickviews
            if ($('.modal-size-chart').length > 0) {
                $('.modal-backdrop').last().css('opacity', '0');
            }
        }
    });
};
